module.exports = __webpack_public_path__ + "img/couples-043.076d7d13.jpg";